import { createFileRoute } from '@tanstack/react-router'
import { AutomationBuilderPage } from '../../../../modules/automations/automation-builder'

/** The visual automation builder at /automations/:id/edit. */
export const Route = createFileRoute('/_authed/automations/$workflowId/edit')({
  component: EditAutomationRoute,
})

function EditAutomationRoute() {
  const { workflowId } = Route.useParams()
  return <AutomationBuilderPage workflowId={workflowId} />
}
